import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PageViewHeaderWithActionBar from '@/components/common/Header/PageViewHeaderWithActionBar.vue'
import ReadContainer from '@calendar/containers/ReadContainer.vue'
import { mapGetters } from 'vuex'
import * as types from '@calendar/store/types'
import * as accountTypes from '@account/store/types'
import api from '@calendar/api'
import { IsSuperadmin, IsCompanyManager } from '@/modules/@appbase/util/permission-helper'
@Component({
    components: { PageViewHeaderWithActionBar, ReadContainer },
    computed: {
        ...mapGetters({
            currentItem: types.CURRENT_CALENDAR_ITEM,
            User: accountTypes.USER,
        })
    }
})
export default class ReadView extends Vue {
    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    currentItem!: calendar.CalendarItem
    User!: account.User

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    actionOpen: boolean = false

    reserveRequestItem: calendar.RequestCalendarMapItem | null = null

    isUpdate: boolean = false
    isDelete: boolean = false

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    async updateItem() {
        // 자원예약 승인 되지 않은것은 수정/삭제 불가 (부킹 테이블에 없는경우...)
        if (this.reserveRequestItem && !this.reserveRequestItem.approvalStatus) {
            await(window as any).alertAsync(this.$t('승인_대기_중입니다').toString())
            return false;
        }

        var target = this.$route.query.target
        this.$router.push(`/calendar/edit?itemid=${encodeURIComponent(this.currentItem.id)}&target=${target}`)
    }

    async deleteItem() {
        // 자원예약 승인 되지 않은것은 수정/삭제 불가 (부킹 테이블에 없는경우...)
        if (this.reserveRequestItem && !this.reserveRequestItem.approvalStatus) {
            await(window as any).alertAsync(this.$t('승인_대기_중입니다').toString())
            return false;
        }

        if (await(window as any).confirmAsync(this.$t('M_Schedule_ConfirmDelete').toString())) {
            if (this.currentItem.isEWS) {
                api.ews_calendar.deleteEvent(this.currentItem.id).then((res) => {
                    if (this.reserveRequestItem) {
                        // 자원 예약 삭제
                        this.conferenceReserveDelete()
                    } else {
                        if (res) this.$router.push('/calendar/main')
                    }
                })
            } else {
                if (this.currentItem.appointmentType == 'Occurrence' || this.currentItem.appointmentType == 'Exception') {
                    api.ews_calendar.deleteEvent(this.currentItem.id).then((res) => {
                        if (res) this.$router.push('/calendar/main')
                    })
                } else {
                    api.db_calendar.deleteCalendarEvent(this.currentItem).then((res) => {
                        if (res) this.$router.push('/calendar/main')
                    })
                }
            }
        } else {
            return false
        }
    }

    async cancelItem() {
        // 자원예약 승인 되지 않은것은 수정/삭제 불가 (부킹 테이블에 없는경우...)
        if (this.reserveRequestItem && !this.reserveRequestItem.approvalStatus) {
            await(window as any).alertAsync(this.$t('승인_대기_중입니다').toString())
            return false;
        }

        if (await(window as any).confirmAsync(this.$t('M_Schedule_ConfirmCancel').toString())) {
            api.ews_calendar.cancelEvent(this.currentItem).then((res) => {
                if (res) this.$router.push('/calendar/main')
            })
        } else {
            return false
        }
    }

    setReserveRequestItem(item: any) {
        this.reserveRequestItem = item
    }

    // 부킹테이블에서 삭제
    conferenceReserveDelete() {

        // if (!await(window as any).confirmAsync(this.$t("정말_취소하시겠습니까").toString())) return

        //this.contentLoaded = false
        //취소인데 선택일정일 때만 bookingItem 만 삭제 한다.

        //const { bookingId, open } = this.$route.query

        let reqParam: any = {
            bookingId: this.reserveRequestItem?.resourceBookingId,
            target: 1 //booking:1, request:0
        }


        api.db_resourceReserve.cancelReserveRequest(reqParam).then(async result => {

            if (result == true) {
                var reserveRequestId = 0
                if (this.reserveRequestItem) {
                    reserveRequestId = this.reserveRequestItem.reserveRequestId
                }
                api.db_resourceReserve.deleteReserveRequestCalendarMap(reserveRequestId).then(async res => {
                    if (res) {
                    // await(window as any).alertAsync(this.$t("예약이_취소되었습니다").toString())   
                        this.$router.push('/calendar/main')
                    } else {
                        await(window as any).alertAsync(this.$t("예약이_취소가_실패하였습니다").toString())
                    }
                    
                })
                
            } else {
                await(window as any).alertAsync(this.$t("예약이_취소가_실패하였습니다").toString())
            }
        }).finally(() => {
            // this.contentLoaded = true
            // this.onCancelClick()
        })
    }

    beforeUpdate() {
        // [이수]
        // 회사일정 본인 및 관리자 삭제 기능
        // 아래 조건에서만 수정 삭제
        // - 최고관리자
        // - 회사관리자
        // - 회사일정관리자
        // - 본인이 작성한것
        var target = this.$route.query.target
        if (target == 'CM') {
            if (IsSuperadmin() || IsCompanyManager()) {
                this.isUpdate = true
                this.isDelete = true
            } else {
                this.isUpdate = this.currentItem.organizer?.address == this.User.email
                this.isDelete = this.currentItem.organizer?.address == this.User.email
            }
        } else {
            this.isUpdate = this.currentItem.isAllowUpdate
            this.isDelete = this.currentItem.isAllowDelete
        }
    }
}
